import { Component } from "vue";
import { WizardStep } from "./WizardStep";
import { WizardModel } from "./WizardModel";

export type WizardPropsProvider<TSharedModel> =
    | Record<string, any>
    | (() => Record<string, any>)
    | ((wizardStep?: WizardStep<TSharedModel>,
        wizardStepContent?: WizardStepContent<TSharedModel>,
        wizardModel?: WizardModel<WizardStep<TSharedModel>, TSharedModel>) => Record<string, any>);

/**
 * WizardStepContent is generic over the "shared model" that the wizard carries.
 * If you don't specify a type, TSharedModel defaults to `any`.
 */
export class WizardStepContent<TSharedModel> {

    constructor(
        public name: string,
        public content: Component,
        // props can be an object or a function returning an object at render time
        public props?: WizardPropsProvider<TSharedModel>
    ) { }
}